import React from 'react'

import { kubernetesTitles } from 'components/attacks/create/targets/kubernetes/kubernetes-target-utils'
import Execution from 'components/attacks/details/Execution'
import Pill from 'components/common/Pill'
import Text from 'components/common/Text'
import theme from 'theme'
import { Execution as ExecutionModel } from 'types/api/attacks/details/execution'

type KubernetesExecutionProps = {
  attackId?: string
  resetViewAll?: () => void
  target?: Record<string, any>
  targetExecutions?: ExecutionModel[]
  viewAll?: boolean
}

const KubernetesExecution: React.FC<KubernetesExecutionProps> = ({
  attackId,
  resetViewAll,
  target,
  targetExecutions,
  viewAll
}) => (
  <div>
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.space[2],
        paddingTop: theme.space[3],
        borderBottom: theme.border.base
      }}
    >
      <Text as="h4" color="medium" css={{ marginLeft: theme.space[0] }}>
        {target.name || target.uid}
      </Text>
      <Pill
        css={{
          marginLeft: theme.space[2]
        }}
      >
        {kubernetesTitles[target.kind]}
      </Pill>
    </div>
    {targetExecutions.map((execution) => (
      <Execution
        key={execution.guid}
        attackId={attackId}
        execution={execution}
        resetViewAll={resetViewAll}
        viewAll={viewAll}
      />
    ))}
  </div>
)

export default KubernetesExecution
